import { generateRootObjectSchema } from "components/cards/common/schema";
import { BaseAtomSpec, generateAtomContainerSchema } from "components/cards/atoms/BaseAtomSpec";
import { ImageParticleSpec } from "components/cards/particles/YinzCam";

export const specification = new BaseAtomSpec("Image Card", generateRootObjectSchema({
  container: generateAtomContainerSchema(),
  image: ImageParticleSpec.generateSchema("Image", "The image."),
}));
